var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 527,
    viewBox: "0 0 1920 527",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".314%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#27AAE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F1FF",
    offset: "38%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFBDED",
    offset: "81%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FED4DA",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D2D3",
    strokeWidth: 3.48,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    d: "m-99.83 253.53 427.37-108.71-3.34 104.25z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D2D3",
    strokeWidth: 3.48,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    d: "m327.54 144.82 381.43 25.1-384.77 79.15zM708.97 169.92l346.17 59.9 623.75-88.31z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D2D3",
    strokeWidth: 3.48,
    fill: "#FFF",
    fillRule: "nonzero",
    strokeLinejoin: "round",
    d: "m1678.89 141.51-969.92 28.41 763.04-107.63z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#D0D2D3",
    strokeWidth: 3.48,
    strokeLinejoin: "round",
    d: "m2115.82 112.96-643.81-50.67-1144.47 82.53L-67.62-27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    fillRule: "nonzero",
    d: "m814.17 197.3 351.97 59.52 612.58-89.06 448.1-27.8-14.51 434.92H0l11.17-294.35 424.03-4.46z",
    transform: "translate(-111 -27)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.2da6c89ad1d23269f111c73aaf0e6d49.svg";
export { ForwardRef as ReactComponent };